var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"splash",class:{ 'splash--leaving': _vm.leaving },on:{"touchmove":function($event){$event.preventDefault();}}},[_c('img',{staticClass:"splash__gif",attrs:{"src":_vm.src,"alt":""},on:{"load":_vm.onLoaded,"error":_vm.enter}})])
}
var staticRenderFns = []

export { render, staticRenderFns }